<template>
  <button class="flex text-sm text-[#008AFC] font-bold gap-1.5 items-center">
    <img class="w-2" src="/src/assets/images/plus-small-icon.svg" alt="">
    <slot />
  </button>
</template>
